import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { buildingCommand } from '../../command/building.command';
import { BuildingService } from '../data/building.service';
import { OtherRentalObject } from '../../model/other-rental-object';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { OtherRentalObjectService } from '../data/other-rental-object.service';

@Injectable()
export class OtherRentalObjectExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: OtherRentalObjectService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.id === rentalObjectCommand.export && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof FilteredCommand) {
      return this._dataService
        .export(command.filterProvider.filterState, command.includedIds, command.excludedIds, command.totalAffectedItemsControlValue)
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
  }
}
